var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchMagnifier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    fillOpacity: 0,
    r: 7,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "M13 13l4.393 4.393"
  })));
}

export default __webpack_public_path__ + "fee732c64aec492f93fab9fbce9bbc8e.svg";
export { SvgSearchMagnifier as ReactComponent };